import { WorkItemsSidebar } from "@/components/WorkItemsSidebar";
import { useWorkItemStream } from "@/hooks/use-work-item-stream";
import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";

type WorkItemsSearch = {
	kind?: string;
	type?: string;
	view?: string;
	status?: string;
	priority?: string;
	assignee?: string;
	customer?: string;
};

export const Route = createFileRoute("/work-items")({
	validateSearch: (search: Record<string, unknown>): WorkItemsSearch => ({
		kind: typeof search.kind === "string" ? search.kind : undefined,
		type: typeof search.type === "string" ? search.type : undefined,
		view: typeof search.view === "string" ? search.view : undefined,
		status: typeof search.status === "string" ? search.status : undefined,
		priority: typeof search.priority === "string" ? search.priority : undefined,
		assignee: typeof search.assignee === "string" ? search.assignee : undefined,
		customer: typeof search.customer === "string" ? search.customer : undefined,
	}),
	component: WorkItemsLayout,
});

function WorkItemsLayout() {
	useWorkItemStream();
	const location = useLocation();
	const isDetailPage = /^\/work-items\/[^/]+$/.test(location.pathname);

	if (isDetailPage) {
		return (
			<div className="h-full overflow-y-auto p-6">
				<Outlet />
			</div>
		);
	}

	return (
		<div className="flex h-full overflow-hidden">
			<WorkItemsSidebar />
			<div className="flex-1 overflow-hidden">
				<Outlet />
			</div>
		</div>
	);
}
